import { FormHelperText } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Link from "@material-ui/core/Link";
import { withStyles } from "@material-ui/core/styles";
import { createBrowserHistory } from "history";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import Loader from "../../../src/components/Loader";
import { subscriptionPlan } from "../../constants/UserAttributes";
import {
  isuserexist,
  userRegisterBySuperAdmin
} from "../../modules/user/redux/action";
import "../../style";
import { isSuperAdmin } from "../Common/CheckAuthorization";
import Button from "../FormElement/Button";
import Dropdown from "../FormElement/Dropdown";
import { validForm } from "../FormElement/FormValidator";
import InputFiled from "../FormElement/InputFiled";

const history = createBrowserHistory();

const styles = {
  root: {
    color: "#00bc84",
    "&$checked": {
      color: "#00bc84"
    }
  },
  checked: {}
};

class Signup extends Component {
  constructor(props) {
    super(props);
    const { farmInfo } = props;
    this.state = {
      user: {
        firstName: farmInfo ? farmInfo.firtName : null,
        lastName: farmInfo ? farmInfo.lastName : null,
        username: farmInfo ? farmInfo.username : null,
        password: "",
        confirmPassword: "",
        streetAddress: farmInfo ? farmInfo.streetAddress : null,
        town: farmInfo ? farmInfo.town : null,
        state: farmInfo ? farmInfo.state : null,
        zipCode: farmInfo ? farmInfo.zipCode : null,
        contactNo: farmInfo ? farmInfo.contactNo : null,
        farmName: farmInfo ? farmInfo.farmName : null,
        farmSize: farmInfo ? farmInfo.farmSize : null,
        subscriptionId: farmInfo ? farmInfo.subscriptionId : "1"
      },
      formErrors: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        streetAddress: "",
        town: "",
        state: "",
        zipCode: "",
        contactNo: "",
        farmName: "",
        farmSize: ""
      },
      termsAndConditionAccepted: false,
      skipVerification: false,
      isValid: true,
      Error: "",
      Success: false,
      fetchingComplete: true,
      allowDataSharing: false
    };
  }
  // handleCheck = () => {
  //   this.setState({
  //     termsAndConditionAccepted: !this.state.termsAndConditionAccepted
  //   });
  // };

  handleCheck = event => {
    let { name, type, value } = event.target;
    if (name === "termsAndConditionAccepted")
      this.setState({
        termsAndConditionAccepted: !this.state.termsAndConditionAccepted
      });
    else if (name === "allowDataSharing") {
      this.setState({
        allowDataSharing: !this.state.allowDataSharing
      });
    }
  };

  handleVerifyCheck = () => {
    this.setState({
      skipVerification: !this.state.skipVerification
    });
  };

  handleChange = event => {
    const { name, value } = event.target;
    console.log(name, value);
    if (name === "contactNo") {
      if (value.match(/^\d{0,15}?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "street_address" || name === "town") {
      if (value.match(/^(.|\n){0,100}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "state" || name === "zipCode") {
      if (value.match(/^(.|\n){0,20}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "firstName" || name === "lastName") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "farmSize") {
      if (value.match(/^\d{0,10}(\.\d{0,2})?$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          user: {
            ...prevState.user,
            [name]: value
          },
          Error: "",
          Success: false,
          fetchingComplete: true
        };
      },
      () => {
        const { user } = this.state;
        const requiredFields = { ...user };
        delete requiredFields.farmSize;
        this.setState({
          isValid: validForm(this.state.formErrors, requiredFields)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.Error && this.props.Error !== nextProps.Error) {
      this.setState({ Error: nextProps.Error, fetchingComplete: true });
    }
    if (nextProps.Success && this.props.Success !== nextProps.Success) {
      this.setState({
        fetchingComplete: true,
        Success: nextProps.Success,
        user: {
          name: "",
          username: "",
          password: "",
          farmAddress: "",
          contactNo: "",
          farmName: "",
          farmSize: ""
        }
      });
    }
  }

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { user } = this.state;
        const requiredFields = { ...user };
        delete requiredFields.farmSize;
        this.setState({
          isValid: validForm(this.state.formErrors, requiredFields)
        });
      }
    );
  };

  onCancel = e => {
    e.preventDefault();
    history.goBack();
  };

  userSignup = e => {
    e.preventDefault();

    const { user, termsAndConditionAccepted, skipVerification } = this.state;
    const formData = { ...user };

    formData.address = {};
    delete formData.streetAddress;
    delete formData.zipCode;
    delete formData.town;
    delete formData.state;
    formData.address.streetAddress = user.streetAddress;
    formData.address.town = user.town;
    formData.address.state = user.state;
    formData.address.zipCode = user.zipCode;
    formData.termsAndConditionAccepted = termsAndConditionAccepted;
    formData.free = skipVerification;
    delete formData.subscriptionId;
    if (skipVerification) {
      formData.subscriptionId = user.subscriptionId;
    }
    formData.allowDataSharing = this.state.allowDataSharing;

    this.setState({ isValid: true, fetchingComplete: false });
    this.props.actions.userRegisterBySuperAdmin(formData);
  };

  validateResetForm = () => {
    const { password, confirmPassword } = this.state.user;
    if (confirmPassword !== "" || confirmPassword !== null)
      return password === confirmPassword;
    else return true;
  };

  render() {
    const {
      user,
      isValid,
      Error,
      Success,
      fetchingComplete,
      termsAndConditionAccepted,
      skipVerification,
      allowDataSharing
    } = this.state;
    const { classes } = this.props;
    if (this.props.userData.user.signupVerified) {
      return <Redirect to="/farmmanagement" />;
    }
    if (Success) {
      return <Redirect to="/farmmanagement" />;
    }
    if (!fetchingComplete && !(Success || this.props.Error)) {
      return <Loader />;
    }
    return (
      <div className="">
        <div className="textRequired">* Required Cells</div>
        <div className="mainform">
          <p className="loginHeader">Create Your Main Farm</p>

          <InputFiled
            value={user.lastName}
            label="Last Name"
            required
            type="text"
            name="lastName"
            validations={["required", "minSize", "maxSize"]}
            handleError={this.handleError}
            handleChange={this.handleChange}
          />
          <InputFiled
            value={user.firstName}
            label="First Name"
            required
            type="text"
            name="firstName"
            validations={["required", "minSize", "maxSize"]}
            handleError={this.handleError}
            handleChange={this.handleChange}
          />
          <InputFiled
            value={user.username}
            placeholder="example@mail.com"
            label="Email/Username"
            type="email"
            validations={["email", "required"]}
            handleChange={this.handleChange}
            handleError={this.handleError}
            name="username"
            required
          />
          {Error.length > 0 && <div className="error">{Error}</div>}
          <InputFiled
            label="Password"
            value={user.password}
            required
            handleChange={this.handleChange}
            handleError={this.handleError}
            validations={["password", "required"]}
            type="password"
            name="password"
          />
          <InputFiled
            value={user.confirmPassword}
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            required
            validations={["required"]}
            handleChange={this.handleChange}
            handleError={this.handleError}
          />
          {!this.validateResetForm() && (
            <FormHelperText>
              <span className="error" role="alert">
                Your password confirmation did not match your password
              </span>
            </FormHelperText>
          )}
          <InputFiled
            label="Street Address"
            value={user.streetAddress}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            multiline
            rows={2}
            rowsMax={4}
            type="text"
            name="streetAddress"
          />
          <InputFiled
            label="Town/City"
            value={user.town}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="town"
          />
          <InputFiled
            label="State"
            value={user.state}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="state"
          />
          <InputFiled
            label="Zip Code"
            value={user.zipCode}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="zipCode"
          />
          <InputFiled
            label="Contact Phone Number"
            required
            value={user.contactNo}
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="contactNo"
          />
          <InputFiled
            label="Name of the Farm"
            value={user.farmName}
            handleChange={this.handleChange}
            handleError={this.handleError}
            validations={["required"]}
            required
            type="text"
            name="farmName"
          />
          <InputFiled
            label="Size of the Farm (in Acres)"
            value={user.farmSize}
            type="text"
            validations={["onlyNumber"]}
            name="farmSize"
            handleChange={this.handleChange}
            handleError={this.handleError}
          />
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={skipVerification}
                  onChange={this.handleVerifyCheck}
                  name="skipVerification"
                  classes={{
                    root: classes.root,
                    checked: classes.checked
                  }}
                />
              }
              label="Skip Email Verification"
              className="mycheckbox"
            />
          </FormGroup>
          {skipVerification && (
            <Dropdown
              value={user.subscriptionId}
              label="Subscription Plan"
              required
              type="text"
              name="subscriptionId"
              options={subscriptionPlan}
              handleChange={this.handleChange}
              //handleError={this.handleError}
            />
          )}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={termsAndConditionAccepted}
                  onChange={this.handleCheck}
                  name="termsAndConditionAccepted"
                  classes={{
                    root: classes.root,
                    checked: classes.checked
                  }}
                />
              }
              label="I agree to the terms and conditions of the website"
              className="mycheckbox"
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={allowDataSharing}
                  onChange={this.handleCheck}
                  name="allowDataSharing"
                  classes={{
                    root: classes.root,
                    checked: classes.checked
                  }}
                />
              }
              label="Opt out from information sharing"
              className="mycheckbox"
            />
          </FormGroup>
          {Success.length > 0 && (
            <div className="success">
              {Success} <a href="/login"> Click here</a>
            </div>
          )}

          <div className="signInSection" style={signInSectionStyle}>
            {isSuperAdmin() && (
              <Link
                className="cancelButton"
                component="button"
                onClick={this.onCancel}
              >
                Cancel
              </Link>
            )}
            <Button
              name="Continue"
              disabled={
                isValid ||
                !this.validateResetForm() ||
                !fetchingComplete ||
                !termsAndConditionAccepted
              }
              onclick={this.userSignup}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    userData: state,
    Error: state.user.Error,
    Success: state.user.Success
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { isuserexist, userRegisterBySuperAdmin },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Signup));

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};



// WEBPACK FOOTER //
// ./src/components/public/MainFarmForm.js